exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".general-tooltip[data-v-433bbddb]{display:inline-flex;height:20px;align-items:center;margin-left:1%;z-index:3;position:relative}.general-tooltip .tooltip-content[data-v-433bbddb]{position:absolute;top:100%;width:281px;max-width:298px;transform:translateX(-50%);color:#fff;background:#3a424e;border-radius:5px;padding:3px 10px;font-size:12px;font-style:normal;font-weight:400;line-height:normal;z-index:999999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-433bbddb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/components/generalTooltip.vue
// module id = 856
// module chunks = 0